import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formControlUse"];
import { memo } from 'react';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { HighlySensitiveDataMaskedDisplay } from '../dataSensitivity/HighlySensitiveDataMaskedDisplay';
import { getDataAttributes } from '../utils/getDataAttributes';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputHighlySensitive = props => {
  const {
      formControlUse
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const theme = useTheme();
  useComponentMountMetric('PropertyInputHighlySensitive');
  const paddingBlock = formControlUse === 'table-cell' ? '0' : formControlUse === 'floating' ? `${theme.space[100]} ${theme.space[50]}` : `${theme.space[200]}`;
  return /*#__PURE__*/_jsx(HighlySensitiveDataMaskedDisplay, {
    dataAttributes: getDataAttributes(rest),
    paddingBlock: paddingBlock
  });
};
export default /*#__PURE__*/memo(PropertyInputHighlySensitive);